'use strict';

var assign = require(199);

var BpmnModdle = require(17);

var packages = {
  bpmn: require(20),
  bpmndi: require(21),
  dc: require(22),
  di: require(23),
  bioc: require(19)
};

module.exports = function(additionalPackages, options) {
  return new BpmnModdle(assign({}, packages, additionalPackages), options);
};
